/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import '../../../scss/custom.scss';
import PropTypes from 'prop-types';
import { TabsSkeleton } from 'carbon-components-react';
import MeRepository from '../../../helpers/api/MeRepository';

export default class DivisionsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      items: [],
      tabSelected: this.props.selectedTab ? this.props.selectedTab : 1 ,
    };
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.tabs = this.tabs.bind(this);
  }

  async componentDidMount() {
    const items = await this.getItems();
    this.setState({ items, loading: false, selectedTab: 2 });
  }


  onSelectionChange = (event) => {
    event.preventDefault();
    const selectedIndex = parseInt(event.target.id, 10);
    //const selectedIndex = event.target.id;
    this.setState({ tabSelected: selectedIndex });
    this.props.onSelectedTab(this.state.items[selectedIndex - 1].id,selectedIndex);
  };

  getItems = async () => {
    let items = [];
    items.unshift({ id: null, name: 'GLOBAL' });
    try {
      items = items.concat(await MeRepository.getDivisions());
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  li = (items, index) =>
    items.map((item, k) => (
      <li
        key={`.li-${k + 1 + index}`}
        className={`bx--tabs__nav-item${
          this.state.tabSelected === k + 1 + index ? ' bx--tabs__nav-item--selected' : ''
        }`}
        data-target={`.tab-${k + 1 + index}`}
        role="tab"
        aria-selected={this.state.tabSelected === k + 1 + index ? 'true' : 'false'}
      >
        <a
          tabIndex="0"
          id={`${k + 1 + index}`}
          className="bx--tabs__nav-link"
          role="tab"
          onClick={this.onSelectionChange}
          aria-controls={`tab-panel-${k + 1 + index}`}
        >
          {item.name}
        </a>
      </li>
    ));

  tabs = () => {
    const divisionTabs = [];
    const { items } = this.state;
    const totalElement = items.length;
    const maxRowElement = 5;
    const rows = Math.ceil(totalElement / maxRowElement);
    let startIndex = 0;
    for (let i = 0; i < rows; i += 1) {
      const endIndex = startIndex + maxRowElement;
      const rowItems = items.slice(startIndex, endIndex);
      const separator = <div key={`.divSeparator-${i + 1}`} className="tab-custom-content" />;

      const slide = (
        <ul key={`.ul-${i + 1}`} className="bx--tabs__nav bx--tabs__nav--hidden" role="tablist">
          {this.li(rowItems, i * maxRowElement)}
        </ul>
      );
      startIndex = endIndex;

      divisionTabs.push(slide);
      if (startIndex > 0) divisionTabs.push(separator);
    }
    return divisionTabs;
  };

  render() {
    return (
      <div className="bx--col-lg-12 bx--tab-container">
        {this.state.loading ? (
          <TabsSkeleton />
        ) : (
          <div data-tabs className="bx--tabs">
            <div className="bx--tabs-trigger">
              <a className="bx--tabs-trigger-text" tabIndex="-1" />
              <svg
                focusable="false"
                preserveAspectRatio="xMidYMid meet"
                style={{ willChange: 'transform' }}
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                aria-hidden="true"
              >
                <path d="M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z" />
              </svg>
            </div>

            {this.tabs()}
          </div>
        )}
      </div>
    );
  }
}
DivisionsTab.propTypes = {
  selectedTab: PropTypes.number,
  onSelectedTab: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
};
DivisionsTab.defaultProps = {
  selectedTab: 1
};
